<template>
  <div id="Place" class="starter-template">
      <div id="startId" style="position:absolute;top:0px;"></div>
      <a href="#" class="toTop" v-scroll-to="'#startId'" v-if="showHand">
          <font-awesome-icon icon="hand-point-up" size="2x" class="mb-5"/>
      </a>

      <div class="text-center">
          <b-spinner variant="primary" class="align-middle" v-if="loading" style="position:absolute;top:50%"></b-spinner>
      </div>

      <div class="modalConf">
          <b-modal id="modalConf">
              <div class="d-block text-center">
                  <h4>{{$t('SURE')}}</h4>
              </div>
              <template v-slot:modal-footer="{ cancel }">
                  <b-button variant="success" @click="cancel()">{{$t('NO')}}</b-button>
                  <b-button variant="danger" @click="actTrip(tripName)">{{$t('YES')}}</b-button>
              </template>
          </b-modal>
      </div>

      <UserTripsListM
          :userName="userName"
          :published="place.published"
          :blocked="place.blocked"
          @actTrip="actTrip"
          v-if="showUT"
          :key="myKey"
      />

      <b-container v-if="csr">
          <div class="descOuter">
            <div v-show="showPlayer">
                <center><audio ref="audio" controls controlsList="nodownload">
                    Аудио не поддерживается</audio>
                </center>
            </div>
            <h1 class="text-center">{{placeName}}</h1>
            <div v-html="desc" class="m-2"></div>
              <div class="m-2 mb-5" v-if="showCmnts">
                <h4>{{$t('CMNTS', resLoc)}}</h4>
                <br>
                <div v-for="item in cmnts" :key="item.cmntName" class="m-2">
                    {{ $fmtDateTime(item.cmntName) }} {{ item.userName }}
                    <br><br>
                    <div v-html="item.desc"></div>
                </div>
            </div>
            <div class="mb8" v-if="$mq === 'md' || $mq === 'sm' || $mq === 'xs'"></div>
            <div v-else class="mb-5"></div>

          </div>


      </b-container>

      <b-container fluid class="footer text-center"  v-if="$mq === 'lg' || $mq === 'xl'">
        <b-button one-line class="m-1 float-left" v-on:click = "showPrev()" v-if="place.prevPlaceName || place.tripName">
            <font-awesome-icon icon="angle-left" size="lg"/>
        </b-button>
        <a v-b-popover.hover.top="this.$t('ADD_TO_TRIP')" title="" v-if="author && !tripName && !place.published">
            <b-button one-line class="m-1" v-on:click = "chooseTrip('addPlaceToTrip')">
                <font-awesome-icon icon="plus" size="lg"/>
            </b-button>
        </a>
        <a v-b-popover.hover.top="this.$t('RM_FROM_TRIP')" title="" v-if="author && tripName">
            <b-button one-line class="m-1" v-on:click = "rmPlaceFromTrip()">
                <font-awesome-icon icon="minus" size="lg"/>
            </b-button>
        </a>
        <a v-b-popover.hover.top="this.$t('COMMENT')" title="" v-if="place.published">
            <b-button one-line class="m-1" v-on:click = "comment()">
                <font-awesome-icon icon="comment" size="lg"/>
            </b-button>
        </a>
          <a v-b-popover.hover.top="$t('MAP')">
            <b-button one-line class="m-1" v-on:click = "showPlaceMarker()">{{ placeName }}</b-button>
          </a>
          <a v-b-popover.hover.top="$t('TRIP_PLACES') " title="" v-show="tripName">
            <b-button one-line class="m-1" v-on:click = "showTripPlacesList()">
                <font-awesome-icon icon="folder-open" size="lg"/>
            </b-button>
          </a>
        <b-button one-line class="m-1 float-right" v-on:click = "showNext()" v-if="place.nextPlaceName">
            <font-awesome-icon icon="angle-right" size="lg"/>
        </b-button>

      </b-container>

      <div  v-else>
          <b-container fluid class="footer1 text-center">
              <a v-b-popover.hover.top="$t('MAP')">
                    <b-button class="m-1 mb-3" v-on:click = "showPlaceMarker()">{{ placeName }}</b-button>
              </a>
          </b-container>
          <b-container fluid class="footer text-center">
              <b-button one-line class="m-1 float-left" v-on:click = "showPrev()" v-if="place.prevPlaceName || place.tripName">
                  <font-awesome-icon icon="angle-left" size="lg"/>
              </b-button>
              <b-button one-line class="m-1" v-on:click = "chooseTrip('addPlaceToTrip')" v-if="author && !tripName && !place.published">
                  <font-awesome-icon icon="plus" size="lg"/>
              </b-button>
              <b-button one-line class="m-1" v-on:click = "rmPlaceFromTrip()" v-if="author && tripName">
                  <font-awesome-icon icon="minus" size="lg"/>
              </b-button>
              <a v-b-popover.hover.top="this.$t('COMMENT')" title="" v-if="place.published">
                  <b-button one-line class="m-1" v-on:click = "comment()">
                    <font-awesome-icon icon="comment" size="lg"/>
                  </b-button>
              </a>
              <a v-b-popover.hover.top="$t('TRIP_PLACES') " title="" v-show="tripName">
                  <b-button one-line class="m-1" v-on:click = "showTripPlacesList()">
                      <font-awesome-icon icon="folder-open" size="lg"/></b-button>
              </a>
              <b-button one-line class="m-1 float-right" v-on:click = "showNext()" v-if="place.nextPlaceName">
                  <font-awesome-icon icon="angle-right" size="lg"/>
              </b-button>

          </b-container>
      </div>
  </div>

</template>

<script>
import { BContainer, BModal, BButton, BSpinner } from 'bootstrap-vue';
import UserTripsListM from '@/components/UserTripsListM.vue'

export default {
  name: 'Place',
  components: {
    UserTripsListM,
    BContainer, BModal, BButton, BSpinner
  },
  data: function() {
    return {
      place: {},
      cmnts: [{}],
      placeName: '',
      userName: '',
      curUserName: '',
      tripName: '',
      intLoc: '',
      resLoc: '',
      desc: '',
      showCmnts: false,
      //title: '',
      audio: '',
      showPlayer: false,
      showUT: false,
      act: '',
      myKey: 0,
      //redir: false,
      metaDesc: null,
      showHand: false,
      loading: false,
      //robots: 'index,follow',
      isUrl: false,
      csr: true,
      placeSSR: '',
      statusCode: 200
    }
  },
  metaInfo() {
/*
    if( location.pathname.includes('%2C') ||
        location.pathname.includes('%3A') ||
        location.pathname.includes('%27') ||
        location.pathname.includes('%28') ||
        location.pathname.includes('%29') )
        return {title: this.outingName}
    else
*/
        return {
            title: this.tripName ? this.tripName + " - " + this.placeName : this.placeName,
            meta: [
            { vmid: 'description', name: 'description', content: this.metaDesc },
            ],
            link: [
                { rel: 'canonical', href: 'https://www.libentour.com'+this.$repl20(location.pathname) }
                //{ rel: 'canonical', href: this.getCanonical() }
                //{ rel: 'canonical', href: this.href() }
            ]
        }
  },
  beforeMount() {
    this.curUserName = this.$store.state.curUserName;
    let userNameIni = this.$route.params.userName;
    let placeNameIni = this.$route.params.itemName;
    //if(this.$isCrowler()) window.location = '/Place/'+placeNameIni+'/'+userNameIni;
    if(this.$isCrowler()) window.location = this.$repl20(location.pathname);
    else {
        this.userName = this.$rmEncHyp(userNameIni);
        this.placeName = this.$rmEncHyp(placeNameIni);
        this.getPlace();
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
/*
    async getCanonical() {
        console.log('https://www.libentour.com'+this.$repl20(location.pathname));
        return 'https://www.libentour.com'+this.$repl20(location.pathname);
    },
*/
    handleScroll () {
        if(document.getElementById('Place')!=null) {
            this.showHand =  window.scrollY > window.innerHeight;
        }
    },
/*
    href () { return 'https://www.libentour.com/Place/'
            +this.$repl20(this.$encodeRFC(this.$addEncHyp(this.placeName)))
            +'/'
            + this.$repl20(this.$encodeRFC(this.$addEncHyp(this.userName)));
    },
*/
    async getPlace() {
        this.loading = true;
        try {
            const response = await this.$http.get('/getPlace', {
                params: {
                    userName: this.userName,
                    placeName: this.placeName,
                    //redir: this.redir
                }
            });
            this.render(response.data);
        }
        catch(error) {
            this.loading = false;
            if(typeof error.response === 'undefined') this.$serveErr('Place: getPlace() '+error.message);
            //else if(error.response.status==301) this.render(error.response.data)
            else {
                this.statusCode = error.response.status;
                this.$showErr(error.response.data, error.response.status);
                //this.$router.push('/');
            }
        }
        finally { this.loading = false; }
    },
    render(place) {
            this.place = place;
            this.resLoc = place.intLoc;
            this.tripName = this.place.tripName;
            this.descMeta();
            this.cmnts = this.place.cmnts;
            if(this.cmnts.length>0) this.showCmnts = true;
            let url =  this.extrURL(this.place.placeDesc);
            if(url) {
                this.isUrl = true; // нужно ли...
                this.$router.go(-1);
                window.open(url, '_blank', 'noopener noreferrer');
            }
            else {
                //this.desc = this.place.placeDesc.replaceAll('src="desc', 'src="/desc');
                this.desc = this.place.placeDesc;
                /*
                console.log(this.desc.substring(0,100));
                console.log(this.desc.substring(this.desc.length-100, this.desc.length));
                */
                if(this.desc.length < 12) this.desc = '<h4>'+this.$t('NO_DESC')+'</h4>';
                if(this.place.audio!="" && typeof this.place.audio!='undefined') {
                    /*
                    console.log(this.place.audio.substring(0, 50));
                    console.log(this.place.audio.substring(this.place.audio.length-100, this.place.audio.length));
                    */
                    this.showPlayer =  true;
                    if(this.place.audio.endsWith('>'))
                        //this.$refs.audio.src = this.place.audio.slice(0, this.place.audio.length-44);
                        this.$refs.audio.src = this.place.audio.slice(0, this.place.audio.length-12);
                    else this.$refs.audio.src = this.place.audio;
              } else this.showPlayer =  false;
            }
            //this.loading = false;
    },
    showPlaceMarker() {
        this.$router.push({
            path: '/Map/PlaceMarker/'+this.$addEncHyp(this.placeName)+'/'+this.$addEncHyp(this.userName)
        })
    },
    showTripPlacesList() {
        this.$router.push({
            path: '/TripPlacesList'+'/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.place.tripAuthorName)
        })
    },
    showTripMarkers() {
        this.$router.push({
            path: '/Map/TripMarkers/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.place.tripAuthorName)
        })
    },
    showPrev() {
        if(this.place.prevPlaceName) {
            this.$router.push({
                path: '/Place/'+this.$addEncHyp(this.place.prevPlaceName)+'/'+this.$addEncHyp(this.place.prevUserName)
            })
        }
        else {
            this.$router.push({
                 path: '/Tour/'+this.$addEncHyp(this.place.tripName)+'/'+this.$addEncHyp(this.place.tripAuthorName)
            })
        }
    },
    showNext() {
        this.$router.push({
            path: '/Place/'+this.$addEncHyp(this.place.nextPlaceName)+'/'+this.$addEncHyp(this.place.nextUserName)
        })
    },
    extrURL(inStr) {
		if(inStr.length < 4) return "";
		let start = 0, fin = 0;
        let found = false;
        // Skip all starting tags
        while( start < (inStr.length-4) ) {
            var mayBe = inStr.substring(start,start+1);
            var mayBeC = mayBe.charCodeAt(0);
            if(mayBeC>255) start = start+1;
            mayBe = inStr.substring(start,start+1);
            if(mayBe=="h") {
                found = true;
                break;
            }
            if(mayBe!="<") return "";
            fin = inStr.indexOf(">", start);
            if(fin >= inStr.length-4) return "";
            start = fin + 1;
        }
        if(!found) return "";
        fin = inStr.indexOf("<", start);
        let urlStr;
        if(fin<0) urlStr = inStr.substring(start, inStr.length);
        else urlStr = inStr.substring(start, fin);
        try {
            urlStr = urlStr.replace("&amp;", "&");
            let url = new URL(urlStr);
            return url.href;
        } catch(_) { return ""; }
    },
    chooseTrip(act) {
        this.act = act;
        this.showUT = true;
    },
    rmPlaceFromTrip() {
        this.act = 'rmPlaceFromTrip';
        this.$bvModal.show('modalConf');
    },
    async actTrip(tripName) {
        this.$bvModal.hide('modalConf');
        if(tripName==='') {
            this.myKey++;
            this.getPlace();
            this.act = '';
            this.showUT = false;
            return;
        }
        try {
            //alert(this.userName + " " + this.place.tripAuthorName + " "+ this.placeName);
            const response = await this.$http.get("/"+this.act, {
                params: {
                    userNameOfP: this.userName,
                    userNameOfT: this.userName,
                    //userNameOfT: this.place.tripAuthorName,
                    placeName: this.placeName,
                    tripName: tripName
                }
            });
            if(this.act=='rmPlaceFromTrip') this.tripName='';
            else this.tripName = tripName;
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    comment() {
        if(!this.curUserName) this.$showMsg(this.$t("REG_FOR_CMNT"), 'info');
        else{
            this.$router.push({
                path: '/ManageCmnt',
                query: {
                    userNameForCmnt: this.$addEncHyp(this.place.userName),
                    itemNameForCmnt: this.$addEncHyp(this.place.placeName),
                    cmntName: '',
                    itemType: 'tp'
                }
            })
        }
    },
    descMeta() {
        if(this.place.metaDesc) {
          this.metaDesc = this.place.metaDesc;
          return;
        }
        let attrs;
        let meta;
        let inj;
        // 150 is defined in MainDriver
        //if(this.isUrl || this.desc.length < 150) this.robots = 'noindex,nofollow';
        if(this.place.resLoc == 'en') {
            attrs = 'attractions';
            meta = 'Description, photo and disposition on map place ';
            inj = ' of tour (set) ';
        } else {
            attrs = 'достопримечательности';
            meta = 'Описание, фото и расположение на карте места ';
            inj = ' тура (сета) ';
        }
        //let meta = this.$t('PLACE_D_F_M') + ' ' + this.placeName;
        meta = meta + this.placeName;
        if(this.place.tripName) meta = meta + inj + this.tripName;
        let refs = false;
        if(this.place.countries.length>0) {
            refs = true;
            for(let i=0; i<this.place.countries.length; i++ )
                meta = meta + ', ' + this.place.countries[i];
        }
        if(this.place.districts)
            for(let i=0; i<this.place.districts.length; i++ )
                meta = meta + ', ' + this.place.districts[i];
        if(this.place.cities)
            for(let i=0; i<this.place.cities.length; i++ )
                meta = meta + ', ' + this.place.cities[i];
        //if(refs) meta = meta + ' ' + this.$t('ATTRS');
        if(refs) meta = meta + ', ' + attrs;
        //console.log(meta);
        //return meta;
        this.metaDesc = meta;
        //console.log(meta);
    }

    },
    computed: {
        author() { return this.userName === this.curUserName },
    },

}

</script>

<style sccoped>
img{
 max-width: 100%;
}
h1{
    font-size: 1.8rem;
}
/*
h4{
    color: blue;
}
*/
</style>
